import { collection, query, getDocs, onSnapshot, Timestamp, addDoc } from 'firebase/firestore';
import { auth, db } from '@/services/firebase/firebase';
import type { Transaction } from '@/types/firebase/earnings';

const transactionsCol = () => {
  if (!auth.currentUser) {
    throw new Error('User not authenticated');
  }
  return collection(db, 'transactions', auth.currentUser.uid, 'items');
};

const isVisibleTransaction = (transaction: Transaction) =>
  transaction.excludedFromAdminMetrics !== true;

export const listTransactions = async (): Promise<Transaction[]> => {
  try {
    const snap = await getDocs(query(transactionsCol()));
    return snap.docs
      .map((d) => ({ id: d.id, ...(d.data() as Omit<Transaction,'id'>) }))
      .filter(isVisibleTransaction);
  } catch (error) {
    console.error('Error listing transactions:', error);
    return [];
  }
};

export const onTransactionsSnapshot = (cb: (tx: Transaction[]) => void) => {
  try {
    return onSnapshot(query(transactionsCol()), 
      (snap) => {
        const items = snap.docs
          .map((d) => ({ id: d.id, ...(d.data() as Omit<Transaction,'id'>) }))
          .filter(isVisibleTransaction);
        cb(items);
      },
      (error) => {
        console.error('Error in transactions snapshot:', error);
        cb([]);
      }
    );
  } catch (error) {
    console.error('Error setting up transactions listener:', error);
    // Return a no-op unsubscribe function
    return () => {};
  }
};

// helper to add demo data (not used in production)
export const addTransaction = async (tx: Omit<Transaction,'id'|'createdAt'>) => {
  try {
    await addDoc(transactionsCol(), { ...tx, createdAt: Timestamp.now() });
  } catch (error) {
    console.error('Error adding transaction:', error);
    throw error;
  }
};
